// オブジェクトの作成
var ISSEYMIYAKE = ISSEYMIYAKE || {};

/**
 * アプリwebview時の制御
 */
ISSEYMIYAKE["isApp"] = {
  check: () => {
    const userAgent = navigator.userAgent;
    const is_app =
      /iPhone|iPad|iPod|Android/i.test(userAgent) &&
      userAgent.includes("Yappli");
    return is_app;
  },
  style: function () {
    if (this.check()) {
      document.addEventListener("DOMContentLoaded", () => {
        // bodyにクラス追加
        document.querySelector("body").classList.add("app");

        // 要素非表示
        const hide_elements = document.querySelectorAll(
          "#shopify-section-header, #shopify-section-breadcrumb, #shopify-section-onlinestore-important-notice, .pagesOnlinestore-detail, .page_onlinestore_selector",
        );
        hide_elements.forEach((element) => {
          element.style.display = "none";
        });

        // mainタグの余白を0に
        document.querySelector("main").style.paddingTop = "0";

        // pickupアイテムの背景色変更
        document.querySelectorAll("._pickup_item")?.forEach((item) => {
          item.style.backgroundColor = "#fff";
          item.querySelector("h1").style.display = "none";
          [...item.querySelectorAll("._more, ._close")].forEach((subItem) => {
            subItem.style.backgroundColor = "#fff";
          });
        });
      });
    }
  },
};

/**
 * 記事検索部分のロジック
 */
ISSEYMIYAKE["articleSearch"] = {
  init: () => {
    const linkContainerItem = document.querySelectorAll(
      "._linkContainer a._link",
    );
    // クリックイベント発生で対応
    linkContainerItem.forEach((elm) => {
      elm.addEventListener("click", (e) =>
        ISSEYMIYAKE.articleSearch.clickEvt(e),
      );
    });
  },
  clickEvt: (e) => {
    e.preventDefault();
    const searchResult = document.querySelector("#Search-In-Template");
    if (searchResult) {
      if (e.target.tagName == "SPAN" || e.target.tagName == "IMG") {
        window.location.href =
          e.target.closest("a").dataset.href + searchResult.value;
      } else {
        window.location.href =
          e.target.closest("a").dataset.href + searchResult.value;
      }
    }
  },
};

/**
 * GETパラメータ取得
 * @param {*} query
 * @returns
 */
ISSEYMIYAKE["getParams"] = (query) => {
  const searchParams = new URLSearchParams(window.location.search);
  const params = {};

  for (let i = 0; i < query.length; i++) {
    if (
      query[i] === "filter.v.m.im-ft.vcolor" ||
      query[i] === "filter.p.vendor" ||
      query[i] === "filter.p.m.im-ft.item_category" ||
      query[i] === "filter.p.tag" ||
      query[i] === "filter.p.product_type"
    ) {
      params[query[i]] = searchParams.getAll(query[i]).join(",");
    } else {
      params[query[i]] = searchParams.get(query[i]);
    }
  }
  return params;
};

/**
 * 配列の空確認
 * @param {*} obj
 * @returns
 */
ISSEYMIYAKE["isEmpty"] = (obj) => {
  let result = false;
  for (let key in obj) {
    if (obj[key]) {
      result = true;
      break;
    }
  }
  return result;
};

/**
 * セクションの更新（フェッチ）
 * @param {*} url
 * @param {*} headers
 * @returns
 */
ISSEYMIYAKE["updateSections"] = (url, headers) => {
  return new Promise((resolve, reject) => {
    fetch(url, headers)
      .then((res) => res.json())
      .then((res) => resolve(res))
      .catch((error) => reject(error));
  });
};

ISSEYMIYAKE["JSONParse"] = (textContent) => {
  try {
    JSON.parse(textContent);
  } catch {
    console.error("予期せぬ値が含まれました");
    return false;
  }
  return JSON.parse(textContent);
};

/**
 * セクション更新
 * @param {*} elm
 * @param {*} target
 */
ISSEYMIYAKE["ajaxUpdate"] = (elm, target) => {
  const parse = new DOMParser();
  const dom = parse.parseFromString(elm, "text/html");
  document.querySelector(target).innerHTML =
    dom.querySelector(target).innerHTML;
};

/**
 * 住所関連
 */
ISSEYMIYAKE["Addresses"] = {
  init: () => {
    const addressFormSubmit = document.querySelectorAll(
      ".wl_edit_address .f-submit",
    );
    const addressFormInput = document.querySelectorAll(
      ".wl_edit_address input[data-name]",
    );
    addressFormSubmit.forEach((btn) => {
      btn.addEventListener("click", (e) => ISSEYMIYAKE.Addresses.clickEvt(e));
    });
    addressFormInput.forEach((input) => {
      input.addEventListener("change", (e) =>
        ISSEYMIYAKE.Addresses.changeEvt(e),
      );
    });
  },
  /**
   * フィールドを更新した際の挙動
   * @param {Event} e
   */
  changeEvt: (e) => {
    const fieldElement = e.target ? e.target.closest("div.field") : null;
    let kanaName = false;
    if (
      e.target.dataset.name == "last_name_kana" ||
      e.target.dataset.name == "first_name_kana"
    ) {
      kanaName = true;
    }
    ISSEYMIYAKE.Addresses.errorClear(e.target);
    ISSEYMIYAKE.Addresses.validationAddress(fieldElement, e.target, kanaName);
  },
  /**
   * クリックした際のイベント
   * @param {Event} e
   * @returns
   */
  clickEvt: (e) => {
    e.preventDefault();
    const target = e.target.closest("form.wl_edit_address");
    const targetField = {};
    targetField["lastName"] = target.querySelector("input[data-last_name]");
    targetField["firstName"] = target.querySelector("input[data-first_name]");
    targetField["lastNameKana"] = target.querySelector(
      "input[data-last_name_kana]",
    );
    targetField["firstNameKana"] = target.querySelector(
      "input[data-first_name_kana]",
    );

    let check = true;
    check = ISSEYMIYAKE.Addresses.validator(targetField, check);

    if (check === false) {
      return false;
    }

    target.querySelector('input[name="address[last_name]"]').value =
      `${targetField.lastNameKana.value} ${targetField.firstNameKana.value}`;
    target.querySelector('input[name="address[first_name]"]').value =
      `${targetField.lastName.value} ${targetField.firstName.value}`;
    target.submit();
  },
  /**
   * バリデーション
   * @param {*} fieldElement
   * @param {*} target
   * @param {*} kanaField
   * @returns
   */
  validationAddress: (fieldElement, target, kanaField = false) => {
    ISSEYMIYAKE.Addresses.errorClear(target);
    const regex = /^[\u30A0-\u30FF]+$/;
    if (!target.value) {
      ISSEYMIYAKE.Addresses.createErrorElement(
        fieldElement,
        target,
        "を入力してください",
      );
      return false;
    }
    if (
      (kanaField == true && !regex.test(target.value)) ||
      (kanaField == true && !regex.test(target.value))
    ) {
      ISSEYMIYAKE.Addresses.createErrorElement(
        fieldElement,
        target,
        "はカタカナで入力してください",
      );
      return false;
    }
    return true;
  },
  /**
   * エラーの削除
   * @param {*} target
   */
  errorClear: (target) => {
    target.classList.remove("error-field");
    const targetError = document.querySelector(
      `#error-for-${target.dataset.name}`,
    );
    if (targetError) {
      targetError.remove();
    }
  },
  /**
   * エラーの作成
   * @param {*} fieldElement
   * @param {*} target
   * @param {*} text
   */
  createErrorElement: (fieldElement, target, text) => {
    const errorElement = document.createElement("p");
    target.classList.add("error-field");
    errorElement.setAttribute(
      "class",
      "field__message field__message--error error-message validation-error",
    );
    errorElement.setAttribute("id", `error-for-${target.dataset.name}`);
    errorElement.innerHTML = target.getAttribute("placeholder") + text;
    fieldElement.querySelector("._namebox").after(errorElement);
    fieldElement.classList.add("field--error");
  },
  /**
   * バリデーションがクリアかの判定
   * @param {*} targetField
   * @param {*} check
   * @returns
   */
  validator: (targetField, check) => {
    let result = false;
    for (const [key, elm] of Object.entries(targetField)) {
      const fieldElement = elm ? elm.closest("div.field") : null;
      if (!fieldElement) {
        return false;
      }
      let kanaName = false;
      if (key == "lastNameKana" || key == "firstNameKana") {
        kanaName = true;
      }
      result = ISSEYMIYAKE.Addresses.validationAddress(
        fieldElement,
        elm,
        kanaName,
      );
      if (result == false) {
        check = false;
      }
    }
    return check;
  },
};
/**
 * 検索関連
 */
ISSEYMIYAKE["Search"] = {
  init: () => {
    const targetForm = document.forms["search"];
    const searchChangeBtn = document.querySelector("#search-change-btn");

    if (searchChangeBtn) {
      searchChangeBtn.addEventListener("click", () =>
        ISSEYMIYAKE.Search.queryChangeEvt(),
      );
    }
    if (targetForm) {
      targetForm.addEventListener("submit", (e) =>
        ISSEYMIYAKE.Search.submitEvt(e),
      );
    }
    ISSEYMIYAKE.Search.setQueryFields();
    ISSEYMIYAKE.Search.sortToggle();
  },
  /**
   * 検索内容の送信
   * @param {*} e
   */
  submitEvt: (e) => {
    e.preventDefault();
    ISSEYMIYAKE.Search.setQuery(e.target);

    const data = ISSEYMIYAKE.Search.processFormData(new FormData(e.target));
    const params = new URLSearchParams(data);
    fetch(`/search?${params}`, {
      method: "GET",
    })
      .then((response) => {
        if (response.ok) {
          window.location.href = response.url;
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  },
  /**
   * Strip `CategoryHandle::` from ec-search item values so Shopify search URLs use plain product_type (e.g. Backpacks).
   */
  stripProductTypeScope: (val) => {
    const s = String(val ?? "").trim();
    const i = s.indexOf("::");
    return i === -1 ? s : s.slice(i + 2).trim();
  },
  stripProductTypeCsv: (csv) =>
    String(csv || "")
      .split(",")
      .map((part) => ISSEYMIYAKE.Search.stripProductTypeScope(part))
      .filter(Boolean)
      .join(","),
  /**
   * dataから値が空白のものを削除し、カンマ区切りの値を分割してdataに追加する関数
   * @param {FormData} data - FormDataオブジェクト
   * @returns {FormData} - 空白の値が削除されたFormDataオブジェクト
   */
  processFormData: (originalData) => {
    const newData = new FormData();
    for (const [key, value] of originalData.entries()) {
      if (value !== "") {
        if (value.includes(",")) {
          const values = value.split(",");
          values.forEach((val) => {
            const t = val.trim();
            if (!t) return;
            const out =
              key === "filter.p.product_type"
                ? ISSEYMIYAKE.Search.stripProductTypeScope(t)
                : t;
            if (out !== "") newData.append(key, out);
          });
        } else {
          const out =
            key === "filter.p.product_type"
              ? ISSEYMIYAKE.Search.stripProductTypeScope(value.trim())
              : value.trim();
          if (out !== "") newData.append(key, out);
        }
      }
    }
    return newData;
  },
  /**
   * なしの場合にdisabled解除
   * @param {*} target
   */
  setQuery: (target) => {
    for (let i = 0; i < target.elements["q"].length; i++) {
      if (
        target.elements["q"][i].value === "" &&
        target.elements["q"][i].classList.contains("keyword")
      ) {
        target.elements["q"][i].disabled = true;
        document.querySelector("#all_search").disabled = false;
      }
    }
  },
  /**
   * 検索条件の変更を押した際のURL生成
   */
  queryChangeEvt: () => {
    if (typeof window.syncEcSearchFiltersFromLocation === "function") {
      window.syncEcSearchFiltersFromLocation();
    }

    const query = [
      "q",
      "filter.p.vendor",
      "filter.p.m.im-ft.item_category",
      "filter.p.tag",
      "filter.v.m.im-ft.vcolor",
      "filter.v.price.gte",
      "filter.v.price.lte",
      "sort_by",
      "filter.v.availability",
      "filter.p.product_type",
    ];
    const params = ISSEYMIYAKE.getParams(query);
    const productTypePlain = params["filter.p.product_type"]
      ? ISSEYMIYAKE.Search.stripProductTypeCsv(params["filter.p.product_type"])
      : "";
    const colorTags =
      localStorage.getItem("filter.p.tag") ||
      params["filter.p.tag"] ||
      params["filter.v.m.im-ft.vcolor"] ||
      "";

    location.href = encodeURI(
      `/search?type=product&keyword=${params.q ? encodeURIComponent(params.q) : ""}&brand=${params["filter.p.vendor"] ? encodeURIComponent(params["filter.p.vendor"]) : ""}&item=${params["filter.p.m.im-ft.item_category"] ? encodeURIComponent(params["filter.p.m.im-ft.item_category"]) : ""}&color=${colorTags ? encodeURIComponent(colorTags) : ""}&price_1=${params["filter.v.price.gte"] ? encodeURIComponent(params["filter.v.price.gte"]) : ""}&price_2=${params["filter.v.price.lte"] ? encodeURIComponent(params["filter.v.price.lte"]) : ""}&sort_by=${params["sort_by"] ? encodeURIComponent(params["sort_by"]) : ""}&availability=${params["filter.v.availability"] ? encodeURIComponent(params["filter.v.availability"]) : ""}&product_type=${productTypePlain ? encodeURIComponent(productTypePlain) : ""}`,
    );
  },
  /**
   * 検索フィールドのセット
   */
  setQueryFields: () => {
    const ecSearch = document.querySelector(".ec-search");
    const query = [
      "keyword",
      "brand",
      "item",
      "color",
      "price_1",
      "price_2",
      "sort_by",
      "product_type",
    ];
    let params = ISSEYMIYAKE.getParams(query);
    const query2 = [
      "q",
      "filter.p.vendor",
      "filter.p.m.im-ft.item_category",
      "filter.p.tag",
      "filter.v.m.im-ft.vcolor",
      "filter.v.price.gte",
      "filter.v.price.lte",
      "sort_by",
      "filter.p.product_type",
      "filter.v.availability",
      "color",
    ];
    let params2 = ISSEYMIYAKE.getParams(query2);

    if (!ecSearch) {
      return false;
    }
    if (
      params.keyword === null &&
      params.brand === null &&
      ecSearch.dataset.searchResults === "0"
    ) {
      params.keyword = params2["q"];
      params.brand = params2["filter.p.vendor"];
      params.item = params2["filter.p.m.im-ft.item_category"];
      params.color =
        params2["color"] ||
        params2["filter.p.tag"] ||
        params2["filter.v.m.im-ft.vcolor"] ||
        localStorage.getItem("filter.p.tag") ||
        "";
      params.price_1 = params2["filter.v.price.gte"];
      params.price_2 = params2["filter.v.price.lte"];
      params.availability = params2["filter.v.availability"];
      params.product_type = params2["filter.p.product_type"];
    }
    Object.keys(params).forEach((query) => {
      let key = query;
      if (query === "keyword") key = "q";
      if (query === "brand") key = "filter.p.vendor";
      if (query === "item") key = "filter.p.m.im-ft.item_category";
      if (query === "color") key = "filter.p.tag";
      if (query === "price_1") key = "filter.v.price.gte";
      if (query === "price_2") key = "filter.v.price.lte";
      if (query === "availability") key = "filter.v.availability";
      if (query === "product_type") key = "filter.p.product_type";
      const target = document.querySelector(
        'form[name="search"] input[name="' + key + '"]',
      );

      if (target && params[query]) {
        target.value =
          params[query] == "*" ? "" : decodeURIComponent(params[query]);
        if (
          target.closest("div").classList.contains("ec-search__optionswrap")
        ) {
          ISSEYMIYAKE.Search.setOptions(target, params, query);
        }
      }
    });
  },
  /**
   * 検索オプションのラベルなどのセット
   * @param {*} target
   * @param {*} params
   * @param {*} query
   */
  setOptions: (target, params, query) => {
    const options = target.closest("div").querySelectorAll(".js-option");
    const decodedValue = decodeURIComponent(params[query]);
    const decodedValuesArray = decodedValue.split(",");
    let active_label = [];

    options.forEach((option) => {
      option.classList.remove("active");
      if (decodedValuesArray.includes(option.dataset.value)) {
        option.classList.add("active");
        active_label.push(`${option.dataset.label}`);
      }
    });

    let htmlLabels = active_label
      .map((label) => {
        if (label.includes("<span")) {
          return label;
        } else {
          return `<span class="label">${label}</span>`;
        }
      })
      .join(",");

    target.closest("div").querySelector(".js-label").innerHTML = htmlLabels;
  },
  /**
   * ソートボタンのクリックイベント
   */
  sortToggle: () => {
    const btn = document.querySelector("._sortOpener");
    const menu = document.querySelector("._sortMenu");
    if (!btn) return false;
    btn.addEventListener("click", (e) => menu.classList.toggle("open"));
    ISSEYMIYAKE.Search.changeSort(btn);
    ISSEYMIYAKE.Search.changeAvailability(btn);
  },
  /**
   * ソートを変更した際の挙動
   */
  changeSort: (btn) => {
    const sort = document.querySelectorAll('input[name="sortState"]');
    sort.forEach((elm) => {
      elm.addEventListener("change", async (e) => {
        const target = document.querySelector("#product-grid");
        let urls = new URL(window.location.href);

        // URLSearchParamsオブジェクトを取得
        let params = urls.searchParams;

        params.set("sort_by", e.target.dataset.sort);
        history.pushState({}, "", "/search?" + params.toString());

        btn.querySelector("._select").innerHTML = e.target.dataset.id;

        const url = `?sections[]=${target.dataset.id}&sections_url=${window.location.pathname}&${params.toString()}`;
        const result = await ISSEYMIYAKE.updateSections(url, {});
        ISSEYMIYAKE.ajaxUpdate(result[target.dataset.id], "#product-grid");
        btn.click(true);
      });
    });
  },
  /**
   * 在庫有無のイベント
   */
  changeAvailability: (btn) => {
    const availability = document.querySelector('input[name="onlyInStock"]');
    const target = document.querySelector("#product-grid");

    // Check the checkbox on page load if filter is set
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("filter.v.availability") === "1" && availability) {
      availability.checked = true;
    }

    if (availability) {
      availability.addEventListener("change", async (e) => {
        let urls = new URL(window.location.href);
        let params = urls.searchParams;

        params.set("filter.v.availability", e.target.checked ? "1" : "");
        history.pushState({}, "", "/search?" + params.toString());

        const url = `?sections[]=${target.dataset.id}&sections_url=${window.location.pathname}&${params.toString()}`;
        const result = await ISSEYMIYAKE.updateSections(url, {});
        ISSEYMIYAKE.ajaxUpdate(result[target.dataset.id], "#product-grid");
        ISSEYMIYAKE.ajaxUpdate(result[target.dataset.id], "#storeitems_head");
        btn.click(true);
        ISSEYMIYAKE["Search"].init();
      });
    }
  },
};

/**
 * 数量制限
 */
ISSEYMIYAKE["QuantityLimit"] = {
  init: async (
    updateQuantity,
    variantId,
    limitQuantity,
    limitVariantItem,
    targetHandle,
  ) => {
    // const items = await ISSEYMIYAKE.QuantityLimit.getCartItem(targetHandle)
    // const result = ISSEYMIYAKE.QuantityLimit.QuantityLimitCheck(items, updateQuantity, variantId, limitQuantity, limitVariantItem)
    const result = true;
    return result;
  },
  /**
   * ターゲットにした商品を取得
   * @param {*} targetHandle
   * @returns
   */
  getCartItem: (targetHandle) => {
    return new Promise((resolve, reject) => {
      fetch(Shopify.routes.root + "cart.js")
        .then((res) => res.json())
        .then((res) => {
          const getItem = res?.items.filter(
            (item) => item.handle === targetHandle,
          );
          resolve(getItem);
        })
        .then((error) => reject(error));
    });
  },
  /**
   * 数量の確認
   * @param {*} items
   * @param {*} updateQuantity
   * @param {*} targetVariantId
   * @param {*} limitQuantity
   * @param {*} limitVariantItem
   * @returns
   */
  QuantityLimitCheck: (
    items = [],
    updateQuantity,
    targetVariantId,
    limitQuantity = 4,
    limitVariantItem = 2,
  ) => {
    updateQuantity = Number(updateQuantity);
    targetVariantId = Number(targetVariantId);

    const error = {
      error: true,
    };

    let quantityCount = updateQuantity;
    let variantQuantity = updateQuantity;
    let upadateFlg = false;
    let countOtherProduct = 0;

    for (let key in items) {
      variantQuantity = updateQuantity;
      if (items[key].variant_id != targetVariantId) {
        quantityCount += items[key].quantity;
        countOtherProduct += items[key].quantity;
      }
    }

    const variant = items.filter((e) => e.variant_id === targetVariantId);
    let variQuantity = variant[0]?.quantity;
    if (
      location.pathname.match(/\/cart/) &&
      variant[0]?.quantity > updateQuantity
    ) {
      variQuantity = variant[0]?.quantity - updateQuantity;
    } else if (
      location.pathname.match(/\/cart/) &&
      variant[0]?.quantity < updateQuantity
    ) {
      variQuantity = updateQuantity;
    } else {
      variQuantity = variant[0]?.quantity + updateQuantity;
    }

    if (quantityCount > limitQuantity) {
      error["value"] = limitQuantity - countOtherProduct;
      error["text"] =
        items[0]?.product_title + " は購入できる数量が制限されています。";
      return error;
    }

    // 商品数量が指定よりもオーバーした場合
    if (
      countOtherProduct + variQuantity > limitQuantity &&
      !location.pathname.match(/\/cart/)
    ) {
      error["value"] = limitQuantity - countOtherProduct;
      error["text"] =
        variant[0]?.product_title + " は購入できる数量が制限されています。";
      return error;
    }

    // バリエーションの数量が指定よりもオーバーした場合
    if (variQuantity > limitVariantItem) {
      error["value"] = limitVariantItem;
      error["text"] =
        variant[0]?.product_title +
        " - " +
        variant[0]?.variant_title +
        " は購入できる数量が制限されています。";
      return error;
    }

    if (quantityCount <= limitQuantity) {
      upadateFlg = true;
    }
    return upadateFlg;
  },
};

/**
 * カート関連
 */
ISSEYMIYAKE["Cart"] = {
  init: () => {
    ISSEYMIYAKE.Cart.shippingErrorObject();
    ISSEYMIYAKE.Cart.noteAttributesUpdate();
    // ISSEYMIYAKE.Cart.lineItemPoint()
  },
  shippingErrorObject: () => {
    const target = document.querySelector("#cart-delivery-datetime_section"); // body要素を監視
    const observer = new MutationObserver(function (mutations) {
      if (target.querySelector(".error-message")) {
        if (target.querySelector(".error-message").childNodes.length === 0) {
          target.querySelector(".error-message").classList.add("hidden");
        }
        if (target.querySelector(".error-message").childNodes.length !== 0) {
          target.querySelector(".error-message").classList.remove("hidden");
        }
      }
    });
    if (target) {
      // 監視を開始
      observer.observe(target, {
        childList: true, // 子ノードの変化を監視
        subtree: true, // 子孫ノードも監視対象に含める
      });
    }
  },
  noteAttributesUpdate: () => {
    // TODO: note部分の修正
    const note = document.querySelector('.cart-price__notes[name="note"]');
    if (note) {
      note.addEventListener("change", (e) => {
        fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            note: e.target.value,
          }),
        });
      });
    }
  },
  /**
   * カートページでのポイント利用関数
   */
  // lineItemPoint: () => {
  //   const lineItem = document.querySelectorAll('form > #main-cart-items .wl-line_item_point')
  //   const usePointElm = document.querySelector('.js-usepoint-text')
  //   const totalPriceElm = document.querySelector('.js-totalprice')
  //   const totalPointElm = document.querySelector('.js-total-point')
  //   const totalPointInputAll = document.querySelectorAll('input[name="attributes[_get_point]"]')
  //   const totalPointInput = document.querySelector('input[name="attributes[_get_point]"]')
  //   const usePoint = usePointElm.dataset.value || 0
  //   let totalPrice = totalPriceElm.dataset.value || 0

  //   const priceObject = ISSEYMIYAKE.Point.pointLogic(lineItem, totalPrice, usePoint, false) || {}

  //   // トータル獲得へ反映
  //   // wl20230302
  //   totalPointElm.innerHTML = Math.sign(priceObject?.totalAddPoint.toNumber()) == 1 ? Math.floor(priceObject?.totalAddPoint.toNumber()).toLocaleString() : 0
  //   // wl20230302
  //   //totalPointInput.value = Math.sign(priceObject?.totalAddPoint.toNumber()) == 1 ? Math.floor(priceObject?.totalAddPoint.toNumber()) : 0
  //   for (let i = 0; i < totalPointInputAll.length; i++) {
  //     totalPointInputAll[i].value = Math.sign(priceObject?.totalAddPoint.toNumber()) == 1 ? Math.floor(priceObject?.totalAddPoint.toNumber()) : 0
  //   }
  //   //fetch(Shopify.routes.root + `cart/update.js?attributes[_get_point]=${totalPointInput.value}`)
  // },
};

/**
 * バリエーションの設定に関する制御
 */
ISSEYMIYAKE["ProductOptionSelect"] = {
  init: (evt = false, event = false) => {
    const noneSetVariant = document.querySelectorAll(".none-set-variant");
    const setVariant = document.querySelectorAll(".set-variant");
    const optionInput = document.querySelectorAll(
      "._buttons .on .product_options_input",
    );
    const colorSelect = document.querySelector("._color ._select");
    const colorFirstText = document.querySelector("._color .first_text");
    const sizeSelect = document.querySelector("._size ._select");
    const sizeFirstText = document.querySelector("._size .first_text");

    // Early return if required elements are missing
    if (!noneSetVariant?.length || !setVariant?.length) {
      console.warn("Required variant elements are missing");
      return;
    }

    const params = new URLSearchParams(location.search);
    if (params.get("variant") || evt === true) {
      if (
        event?.target?.getAttribute("name") === "Size" ||
        event?.target?.getAttribute("name") === "サイズ"
      ) {
        ISSEYMIYAKE["ProductOptionSelect"].setVariantSetting(
          setVariant,
          noneSetVariant,
          optionInput,
          sizeSelect,
          event.target.value,
        );
        sizeFirstText?.classList?.add("hidden");
      } else if (
        event?.target?.getAttribute("name") === "Color" ||
        event?.target?.getAttribute("name") === "カラー"
      ) {
        ISSEYMIYAKE["ProductOptionSelect"].setVariantSetting(
          setVariant,
          noneSetVariant,
          optionInput,
          colorSelect,
        );
        colorFirstText?.classList?.add("hidden");
        sizeFirstText?.classList?.remove("hidden");
        if (sizeSelect && sizeFirstText) {
          ISSEYMIYAKE["ProductOptionSelect"].checkOption2Value(
            event.target.value,
            sizeSelect,
            sizeFirstText,
          );
        }
      } else {
        ISSEYMIYAKE["ProductOptionSelect"].setVariantSetting(
          setVariant,
          noneSetVariant,
          optionInput,
          colorSelect,
        );
      }
    } else {
      ISSEYMIYAKE["ProductOptionSelect"].noneSetVariantSetting(
        colorFirstText,
        sizeFirstText,
        setVariant,
        noneSetVariant,
        colorSelect,
        sizeSelect,
      );
    }
  },
  /**
   * バリエーションが設定された場合
   * @param {*} setVariant
   * @param {*} noneSetVariant
   * @param {*} optionInput
   * @param {*} colorSelect
   */
  setVariantSetting: (
    setVariant,
    noneSetVariant,
    optionInput,
    select,
    value = false,
  ) => {
    noneSetVariant.forEach((e) => {
      e.classList.add("hidden");
    });
    setVariant.forEach((e) => {
      e.classList.remove("hidden");
    });
    select?.classList.remove("hidden");

    if (value) {
      select.innerHTML = value;
    }
    optionInput.forEach((e) => {
      if (e?.dataset.id === select?.innerHTML) {
        e.checked = true;
      }
    });
  },
  /**
   * バリエーションが選択されている状態の場合の処理
   * @returns
   */
  hasVariantId() {
    const variantId = ISSEYMIYAKE["getParams"](["variant"]);
    const colorFirstText = document.querySelector("._color .first_text");
    const sizeFirstText = document.querySelector("._size .first_text");
    if (!variantId) return false;

    if (variantId.variant !== null && colorFirstText && sizeFirstText) {
      sizeFirstText.classList?.add("hidden");
      colorFirstText.classList?.add("hidden");
    }

    const variantData = document.querySelector("#variantData");
    const variants = ISSEYMIYAKE["JSONParse"](variantData?.textContent);
    if (!variants) return false;

    const variant = variants.filter(
      (variant) => variant.id == Number(variantId.variant),
    );
    if (variant.length === 0) return false;

    // Add null checks for all querySelector operations
    const option1Element = document.querySelector(
      `[data-id="${variant[0].option1}"]`,
    );
    const option2Element = document.querySelector(
      `[data-color="${variant[0].option1}"] [data-id="${variant[0].option2}"]`,
    );
    const inStockElement = document.querySelector("._in_stock.on");

    if (!option1Element || !option2Element || !inStockElement) {
      console.warn("Some variant elements are missing");
      return false;
    }

    option1Element.checked = true;
    option2Element.checked = true;
    inStockElement.disabled = variant[0].available;
    return true;
  },
  /**
   * option1（カラー）を選択した時にoption2（基本的に"サイズ"）が1種類か確認、1種類の場合自動で選択する
   */
  checkOption2Value(value, sizeSelect, sizeFirstText) {
    const variantData = document.querySelector("#variantData");
    const variants = ISSEYMIYAKE["JSONParse"](variantData?.textContent);
    const variantBisOnCheck = JSON.parse(
      document.getElementById("variantsOtherData").textContent,
    );
    const submitForm = document.querySelector("#main .products-detail .form");
    const out_of_notification_stock_text = document.querySelector(
      "._out_of_stock_notification_text",
    );
    const arrival_notification = document.querySelector(
      "._arrival_notification",
    );
    const out_of_stock = document.querySelector("._out_of_stock");
    const out_of_stock_text = document.querySelector("._out_of_stock_text");
    const photo = document.querySelectorAll(".f-enlargedImageOpen img");
    var optAllArr = [];
    var optAllArr2 = [];

    for (let i = 0; variants.length > i; i++) {
      var optArr = {};
      optArr.id = variants[i].id;
      optArr.name = variants[i].name;
      if (variants[i].featured_image === null) {
        optArr.image = photo[0].src;
      } else {
        optArr.image = variants[i].featured_image.src;
      }
      optArr.available = variants[i].available;
      optArr.option = variants[i].option2;
      optAllArr.push(optArr);
    }
    for (let j = 0; variantBisOnCheck.length > j; j++) {
      var opt2Arr = {};
      opt2Arr.id = variantBisOnCheck[j].id;
      opt2Arr.is_can_restock = variantBisOnCheck[j].is_can_restock;
      optAllArr2.push(opt2Arr);
    }
    const optFinalArr = [];
    for (let i = 0; i < optAllArr.length; i++) {
      const index = optAllArr2.findIndex((obj) => obj.id === optAllArr[i].id);
      if (index !== -1) {
        optFinalArr.push({
          id: optAllArr[i].id,
          name: optAllArr[i].name,
          image: optAllArr[i].image,
          available: optAllArr[i].available,
          option: optAllArr[i].option,
          is_can_restock: optAllArr2[index].is_can_restock,
        });
      } else {
        optFinalArr.push(optAllArr[i]);
      }
    }
    if (optFinalArr.every((v) => v.option === optFinalArr[0].option)) {
      const targetColor = document.querySelector(
        `[data-color="${value}"] input`,
      );
      const targetId = targetColor ? targetColor.id : null;
      const targetArrItem = targetId
        ? optFinalArr.find((item) => item.id == targetId)
        : null;
      const targetBuyBtn = document.querySelector("._in_stock.on");
      sizeFirstText.classList.add("hidden");
      sizeSelect.innerHTML = optFinalArr[0].option;
      const variantId = submitForm.querySelector('input[name="id"]');
      variantId.value = targetId;
      const wishlistBtn = document.querySelector("wish-list-button");
      wishlistBtn.setAttribute("product-variant-id", targetId);
      // const wishlistName = document.querySelector('.swym-details strong');
      // wishlistName.innerHTML = targetArrItem.name;
      const wishlistImg = document.querySelector(".swym-product-tile img");
      wishlistImg.src = targetArrItem.image;

      if (targetArrItem) {
        const targetAvailable = targetArrItem.available;
        const targetItemBIS = targetArrItem.is_can_restock;

        targetColor.checked = true;
        targetBuyBtn.classList.remove("hidden");

        if (!targetAvailable) {
          if (targetItemBIS) {
            targetBuyBtn.classList.add("hidden");
            arrival_notification.classList.add("on");
            out_of_notification_stock_text.classList.add("on");
          } else {
            targetBuyBtn.disabled = true;
            out_of_stock.classList.add("add");
            out_of_stock_text.classList.add("add");
          }
        } else {
          targetBuyBtn.disabled = false;
        }
      } else {
        console.log("error");
      }
    }
  },
  /**
   * バリエーションが設定されていない場合
   * @param {*} setVariant
   * @param {*} noneSetVariant
   * @param {*} colorSelect
   */
  noneSetVariantSetting: (
    colorFirstText,
    sizeFirstText,
    setVariant,
    noneSetVariant,
    colorSelect,
    sizeSelect,
  ) => {
    // Add null checks for DOM elements
    if (
      !colorFirstText ||
      !sizeFirstText ||
      !setVariant ||
      !noneSetVariant ||
      !colorSelect ||
      !sizeSelect
    ) {
      console.warn(
        "Some required DOM elements are missing for variant settings",
      );
      return;
    }

    const onlyColor = colorFirstText.classList.contains("only_one_color");
    const onlySize = document.querySelector("._button__number");
    // Add null check for onlySize
    const ifOnlySize = onlySize?.classList.contains("only_one_option") || false;

    setVariant.forEach((e) => {
      e.classList.add("hidden");
    });
    noneSetVariant.forEach((e) => {
      e.classList.remove("hidden");
    });
    if (onlyColor) {
      colorFirstText.classList.add("hidden");
      if (ifOnlySize && onlySize) {
        // Add null check for onlySize
        sizeFirstText.classList.add("hidden");
        sizeSelect.innerHTML = onlySize.innerHTML;
        setVariant.forEach((e) => {
          e.classList.remove("hidden");
        });
        noneSetVariant.forEach((e) => {
          e.classList.add("hidden");
        });
      }
    } else {
      colorSelect.classList.add("hidden");
      colorFirstText.classList.remove("hidden");
      sizeFirstText.classList.add("hidden");
    }
  },
};

document.addEventListener("DOMContentLoaded", () => {
  // Check if we're on a product page (you can adjust this check based on your needs)
  if (document.querySelector("._color") || document.querySelector("._size")) {
    ISSEYMIYAKE.ProductOptionSelect.hasVariantId();
  }
});
